import type { StorageStrategy } from '@components/room/streaming-debugger/stores/logger/storage-strategy/index';
import type { LogEntry } from '@components/room/streaming-debugger/stores/logger/types';

export class MemoryStrategy implements StorageStrategy {
    private logs: LogEntry[] = [];

    async init(): Promise<void> {
        this.clear();
    }

    async add(log: LogEntry): Promise<void> {
        this.logs.push(log);
    }

    async getAll(): Promise<LogEntry[]> {
        return this.logs;
    }

    async clear(): Promise<void> {
        this.logs = [];
    }
}
